import React, { useState, useEffect } from 'react';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-50 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <p className="text-xs text-gray-500 font-body leading-relaxed text-center md:text-left max-w-4xl">
          This website uses cookies to make the experience of this website better. By continuing past this notice and by using this website, you consent to the use of cookies and to all the other terms and conditions in this website's Terms of Use and Privacy Policy. You can read our <a href="/support?section=privacy" className="underline hover:text-black">Privacy Policy</a> and <a href="/support?section=terms" className="underline hover:text-black">Terms of Use</a>.
        </p>
        <button 
          onClick={handleAccept}
          className="whitespace-nowrap bg-black text-white px-8 py-3 font-heading font-bold text-xs tracking-widest hover:bg-gray-800 transition-colors uppercase"
        >
          I Understand
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
